/** @format */

const template = `
<div class="search-filter credit-range-filter">
  <ng-form name="filterSelectorForm" novalidate ng-model-options="{ updateOn: 'default' }">
    <div class="input-group">
      <div class="row">
        <div class="col-9">
          <div class="row">
            <div class="col-5">
              <input
                type="number"
                placeholder="min"
                min="0"
                class="form-control search-range-min"
                ng-model="ctrl.selectedCredits.min"
                tabindex="0" />
            </div>
            <div class="col-1 search-filter-gutter">
              <span class="hyphen">–</span>
            </div>
            <div class="col-5">
              <input
                type="number"
                placeholder="max"
                min="{{ctrl.selectedCredits.min}}"
                class="form-control search-range-max"
                ng-model="ctrl.selectedCredits.max"
                tabindex="0" />
            </div>
          </div>
          <div ng-if="ctrl.helpText" class="row help-block">
            <div class="col-12">
              <p>{{ctrl.helpText}}</p>
            </div>
          </div>
        </div>
        <div class="col-3">
          <button
            type="submit"
            class="btn btn-lg btn-primary filter-submit"
            ng-click="ctrl.submitRangeFilter()"
            ng-disabled="filterSelectorForm.$pristine || filterSelectorForm.$invalid"
            translate="SEARCH.FILTER_SELECTOR.OK">
          </button>
        </div>
      </div>
    </div>
  </ng-form>
</div>
`;
export default template;
